import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

const GradingTemplatesQuery = graphql.persisted(
  "GradingTemplatesQuery",
  graphql(`
    query GradingTemplatesQuery($schoolId: ID!) {
      school(id: $schoolId) {
        id
        gradingTemplates {
          id
          name
          description
          weightTotal
          categories {
            id
            name
            weight
            dropLowest
            position
          }
        }
      }
    }
  `)
);

export { GradingTemplatesQuery };

export function useGradingTemplatesQuery(schoolId: string | undefined) {
  return useQuery(GradingTemplatesQuery, {
    variables: { schoolId: schoolId! },
    skip: !schoolId,
    fetchPolicy: 'cache-and-network',
  });
}
